import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import Count from './Count'
import InputSearchTemplate from './InputSearchTemplate'
import TableTemplate from './TableTemplate'
import classes from './index.module.scss'
import { changeTemplates } from './store/slice'

const Templates = ({ backToDetailTemplate, template, openTemplate }) => {
  const dispatch = useDispatch()

  const { data, ids, callApi, loading, total, deleteTemplate, updateTemplate } =
    template

  useEffect(() => {
    dispatch(changeTemplates(data))
  }, [data])

  return (
    <Element style={{ color: '#3A414B' }} className={classes.templateContainer}>
      <div>
        <Element
          style={{ border: '1px solid #D5D5D5' }}
          className={classes.btnBack}
          onClick={backToDetailTemplate}
        >
          <Icon className="icon-arrow-left" style={{ fontSize: 8 }} />
          <Translate value="preferenceSetting.BACK_SETTING" />
        </Element>
        <Element
          style={{ fontSize: 24, color: '#0553A5' }}
          className={classes.title}
        >
          <Translate value="preferenceSetting.ALL_TEMPLATE" />
        </Element>
      </div>
      <div className={classes.inputContainer}>
        <div className={classes.w320}>
          <InputSearchTemplate callApi={callApi} />
        </div>
      </div>
      <div className={classes.mt12}>
        <Count deleteTemplate={deleteTemplate} total={total} ids={ids} />
      </div>
      <TableTemplate
        loading={loading}
        total={total}
        deleteTemplate={deleteTemplate}
        openTemplate={openTemplate}
        updateTemplate={updateTemplate}
      />
    </Element>
  )
}

export default Templates
